import { useRandomAsset } from "../../hooks/useRandomAsset"
import { usePluginConfig } from "../../contexts/pluginContext"

const WidgetPromotionalAsset = ({ widgetType, utmSource, utmMedium, utmCampaign, customAdClasses }) => {
  const pluginConfig = usePluginConfig();
  const publisherSettings = pluginConfig.publisherSettings;
  const promotionalAsset = useRandomAsset(widgetType);

  if (!promotionalAsset) {
    return null;
  }

  const promoteUrl =
    `${process.env.EVVNT_FORM_URL}?` +
    `partner=${publisherSettings.api_key}&publisher_id=${publisherSettings.publisher?.id}` +
    `&utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}`;

  return (
    <div className="c-card block row-span-2 relative overflow-hidden bg-white rounded border w-full @sm:max-w-lg m-auto">
      <div className={`flex items-center justify-center h-full p-1 evvnt-ad`}>
        <a href={promoteUrl} target="_blank" rel="noopener">
          <img src={promotionalAsset.image_url} className={customAdClasses} alt="Promote your event" />
        </a>
      </div>
    </div>
  );
};

export default WidgetPromotionalAsset;
